import React from 'react';

import backgroundImage from '../../images/backgroundImage.png';
import '../../scss/components/error/page_error.scss';

const Page500 = () => {
  let title = '調整班表時，請使用非行動裝置。<br />例如: 筆電、桌電等';
  return (
    <div className="page-404">
      <div className="image-block" style={{backgroundImage: `url('${backgroundImage}')`}}></div>
      <div className="title" dangerouslySetInnerHTML={{__html: title}}></div>
    </div>
  );
}

export default Page500;